export const BASE_URL = "https://api.topdev.asia/";

export interface IEvent {
  id: number;
  image_url: string;
  event_url: string;
  title: string;
  description: string;
  tracking_type: "click" | "view";
}

export type SourceType = "frontend" | "resume-dash" | "blog" | "frontend-v3";
export interface IEventInformation {
  source?: SourceType;
}

export interface IResponseEvent {
  data: IEvent[];
}

export type SubscribedType = {
  id: number;
};
export interface ISubscribed {
  status: string;
  message: string;
}

export type PostSubscribedType = {
  event_id: number;
  email?: string | null;
  phone?: string | null;
  event_action?: string | null;
};

const setCookie = (cname: string, cvalue: number, exdays: number) => {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

const getCookie = (cname: string) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export { setCookie, getCookie };
